module.exports = __webpack_public_path__ + "img/QRCodeTest.209fafa2.png";